import React, { useEffect, useState } from 'react';
import API from '../api';
import Navbar from '../components/Navbar';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

const Customers = () => {
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState('');
    const [isVip, setIsVip] = useState(false);
  const [phone, setPhone] = useState('');
  const [search, setSearch] = useState('');
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [history, setHistory] = useState(null);
  const [creditAmount, setCreditAmount] = useState('');
  const [creditNote, setCreditNote] = useState('');
  const [paymentAmount, setPaymentAmount] = useState('');
  const [paymentNote, setPaymentNote] = useState('');
  const [activeTab, setActiveTab] = useState('credit');
  const [customerInvoices, setCustomerInvoices] = useState(null);
const [loadingInvoices, setLoadingInvoices] = useState(false);
const [importing, setImporting] = useState(false);
const [importResult, setImportResult] = useState(null);

  const [vipStats, setVipStats] = useState({});

  const fetchCustomers = async () => {
    setLoading(true);
    try {
      const res = await API.get('/customers');
      setCustomers(res.data);
      const statsRes = await API.get('/customers/vip-stats');
      const statsMap = {};
      statsRes.data.forEach((s) => { statsMap[s.customer_id] = s; });
      setVipStats(statsMap);
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };
  const handleImport = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setImporting(true);
    setImportResult(null);
    try {
      const formData = new FormData();
      formData.append('file', file);
      const res = await API.post('/customers/import', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setImportResult(res.data);
      toast.success(res.data.message);
      fetchCustomers();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Import failed');
    }
    setImporting(false);
    e.target.value = '';
  };

  const downloadTemplate = () => {
    const template = `Name,Phone,Outstanding Balance\n# DELETE EXAMPLE ROWS AND ADD YOUR CUSTOMERS\nAhmed (EXAMPLE - DELETE),0771234567,15000\nSuresh (EXAMPLE - DELETE),0761234567,0\nMary (EXAMPLE - DELETE),0751234567,5500`;
    const blob = new Blob([template], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'wahi-pos-customers-template.csv';
    a.click();
  };

const fetchCustomerInvoices = async (customerId) => {
    setLoadingInvoices(true);
    try {
      const res = await API.get(`/customers/${customerId}/invoices`);
      setCustomerInvoices(res.data);
    } catch (err) {
      console.error(err);
    }
    setLoadingInvoices(false);
  };

  useEffect(() => {
    fetchCustomers();
  }, []);

  const [addingCustomer, setAddingCustomer] = useState(false);

  const handleAddCustomer = async (e) => {
    e.preventDefault();
    if (addingCustomer) return;
    setAddingCustomer(true);
    try {
      await API.post('/customers', { name, phone, is_vip: isVip });
      toast.success(isVip ? 'VIP Customer added!' : 'Customer added!');
      setName('');
      setPhone('');
      setIsVip(false);
      fetchCustomers();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to add customer');
    }
    setAddingCustomer(false);
  };

  const handleViewHistory = async (customer) => {
    setSelectedCustomer(customer);
    setCustomerInvoices(null);
    fetchCustomerInvoices(customer.id);
    try {
      const res = await API.get(`/customers/${customer.id}/history`);
      setHistory(res.data);
    } catch (err) {
      toast.error('Failed to load history');
    }
  };
  const handleDeleteCustomer = async (customer) => {
    if (!window.confirm(`Delete customer "${customer.name}"? This cannot be undone.`)) return;
    try {
      await API.delete(`/customers/${customer.id}`);
      toast.success('Customer deleted!');
      setSelectedCustomer(null);
      setHistory(null);
      fetchCustomers();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to delete customer');
    }
  };

  const handleAddCredit = async () => {
    if (!creditAmount || creditAmount <= 0) {
      toast.error('Enter valid amount');
      return;
    }
    try {
      await API.post(`/customers/${selectedCustomer.id}/credit`, {
        amount: parseFloat(creditAmount),
        note: creditNote,
      });
      toast.success('Credit added!');
      setCreditAmount('');
      setCreditNote('');
      handleViewHistory(selectedCustomer);
      fetchCustomers();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to add credit');
    }
  };

  const handleAddPayment = async () => {
    if (!paymentAmount || paymentAmount <= 0) {
      toast.error('Enter valid amount');
      return;
    }
    try {
      await API.post(`/customers/${selectedCustomer.id}/payment`, {
        amount: parseFloat(paymentAmount),
        note: paymentNote,
      });
      toast.success('Payment recorded!');
      setPaymentAmount('');
      setPaymentNote('');
      handleViewHistory(selectedCustomer);
      fetchCustomers();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to record payment');
    }
  };

  const filteredCustomers = customers.filter((c) =>
    c.name.toLowerCase().includes(search.toLowerCase()) ||
    (c.phone && c.phone.includes(search))
  );

  const [showAllVip, setShowAllVip] = useState(false);
  const [showAllCredit, setShowAllCredit] = useState(false);

  const vipList = filteredCustomers
    .filter((c) => c.is_vip)
    .sort((a, b) => (vipStats[b.id]?.gross_profit || 0) - (vipStats[a.id]?.gross_profit || 0));

  const creditList = filteredCustomers
    .filter((c) => !c.is_vip)
    .sort((a, b) => parseFloat(b.balance) - parseFloat(a.balance));
  return (
    <div>
      <Navbar />
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
      <div style={styles.container} className="container">
        <h2 style={styles.title}>Credit Customers</h2>


{customers.filter(c => parseFloat(c.balance) > 0).length > 0 && (  
  
  <div style={styles.outstandingBox}>
    <p style={styles.outstandingTitle}>
      ⚠️ Outstanding Balance — {customers.filter(c => parseFloat(c.balance) > 0).length} customers owe money
    </p>
    <div style={styles.outstandingList}>
      {customers
        .filter(c => parseFloat(c.balance) > 0)
        .sort((a, b) => parseFloat(b.balance) - parseFloat(a.balance))
        .map(c => (
          <div key={c.id} style={styles.outstandingItem}>
            <span style={styles.outstandingName}>{c.name}</span>
            <span style={styles.outstandingBalance}>LKR {parseFloat(c.balance).toFixed(2)}</span>
          </div>
        ))}
    </div>
    <div style={styles.outstandingTotal}>
      <span>Total Outstanding:</span>
      <span style={{ color: '#ef4444', fontWeight: 'bold' }}>
        LKR {customers.filter(c => parseFloat(c.balance) > 0).reduce((sum, c) => sum + parseFloat(c.balance), 0).toFixed(2)}
      </span>
    </div>
  </div>
)}
        <div style={styles.card}>
<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
  <h3 style={{ fontSize: '16px', margin: 0 }}>Add New Customer</h3>
  <div style={{ display: 'flex', gap: '0.5rem' }}>
    <button onClick={downloadTemplate} style={styles.templateBtn}>
      📥 Download Template
    </button>
    <label style={styles.importBtn}>
      {importing ? '⏳ Importing...' : '📤 Import CSV'}
      <input
        type="file"
        accept=".xlsx,.xls,.csv"
        onChange={handleImport}
        style={{ display: 'none' }}
        disabled={importing}
      />
    </label>
  </div>
</div>          <form onSubmit={handleAddCustomer} style={styles.form} className="form">
            <input style={styles.input} type="text" placeholder="Customer Name" value={name} onChange={(e) => setName(e.target.value)} required />
            <input style={styles.input} type="text" placeholder="Phone Number" value={phone} onChange={(e) => setPhone(e.target.value)} />
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', cursor: 'pointer', padding: '10px' }}>
              <input type="checkbox" checked={isVip} onChange={(e) => setIsVip(e.target.checked)} />
              ⭐ VIP Customer (always pays in full)
            </label>
<button style={{ ...styles.button, opacity: addingCustomer ? 0.6 : 1 }} type="submit" disabled={addingCustomer}>
              {addingCustomer ? 'Adding...' : 'Add Customer'}
            </button>          </form>
          {importResult && (
  <div style={styles.importResult}>
    <p style={{ fontWeight: '600', marginBottom: '0.5rem' }}>
      ✅ {importResult.imported} imported | ⚠️ {importResult.skipped} skipped
    </p>
    {importResult.errors?.length > 0 && (
      <div>
        {importResult.errors.map((e, i) => (
          <p key={i} style={{ fontSize: '12px', color: '#ef4444' }}>• {e}</p>
        ))}
      </div>
    )}
  </div>
)}


          
        </div>

        <input
          style={styles.search}
          type="text"
          placeholder="Search by name or phone..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <div style={styles.layout} className="layout">
          {loading ? (
            <div style={styles.loaderWrapper}>
              <div style={styles.spinner}></div>
              <p style={styles.loaderText}>Loading customers...</p>
            </div>
          ) : (
            <div style={{ flex: 2, minWidth: '400px' }}>
              {vipList.length > 0 && (
                <div style={{ marginBottom: '1.5rem' }}>
                  <h3 style={{ fontSize: '15px', marginBottom: '0.5rem' }}>⭐ VIP Customers — sorted by most profit</h3>
                  <div className="mobile-scroll-wrapper"><p className="mobile-scroll-hint">← Swipe to see more →</p><table style={styles.table}>
                    <thead>
                      <tr>
                        <th style={styles.th}>Name</th>
                        <th style={styles.th}>Phone</th>
                        <th style={styles.th}>Revenue</th>
                        <th style={styles.th}>Profit</th>
                        <th style={styles.th}>Returned</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(showAllVip ? vipList : vipList.slice(0, 5)).map((c) => {
                        const vip = vipStats[c.id] || { total_revenue: 0, gross_profit: 0, total_returned: 0 };
                        return (
                          <tr
                            key={c.id}
                            onClick={() => handleViewHistory(c)}
                            style={{ ...styles.row, background: selectedCustomer?.id === c.id ? '#e0e7ff' : '#fff' }}
                          >
                            <td style={styles.td}>⭐ {c.name}</td>
                            <td style={styles.td}>{c.phone || '-'}</td>
                            <td style={styles.td}>LKR {vip.total_revenue.toFixed(2)}</td>
                            <td style={{ ...styles.td, color: '#16a34a' }}>LKR {vip.gross_profit.toFixed(2)}</td>
                            <td style={{ ...styles.td, color: vip.total_returned > 0 ? '#ef4444' : '#888' }}>LKR {vip.total_returned.toFixed(2)}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table></div>
                  {vipList.length > 5 && (
                    <button onClick={() => setShowAllVip(!showAllVip)} style={{ marginTop: '0.5rem', padding: '6px 14px', background: '#fff', color: '#92400e', border: '1px solid #fde68a', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}>
                      {showAllVip ? '▲ Show less' : `▼ Show all ${vipList.length}`}
                    </button>
                  )}
                </div>
              )}

              <h3 style={{ fontSize: '15px', marginBottom: '0.5rem' }}>💳 Credit Customers — sorted by highest balance</h3>
              <div className="mobile-scroll-wrapper"><p className="mobile-scroll-hint">← Swipe to see more →</p><table style={styles.table}>
                <thead>
                  <tr>
                    <th style={styles.th}>Name</th>
                    <th style={styles.th}>Phone</th>
                    <th style={styles.th}>Total Credit</th>
                    <th style={styles.th}>Total Paid</th>
                    <th style={styles.th}>Balance</th>
                  </tr>
                </thead>
                <tbody>
                  {creditList.length === 0 ? (
                    <tr>
                      <td colSpan="5" style={{ ...styles.td, textAlign: 'center', color: '#888' }}>No customers found</td>
                    </tr>
                  ) : (
                    (showAllCredit ? creditList : creditList.slice(0, 5)).map((c) => (
                      <tr
                        key={c.id}
                        onClick={() => handleViewHistory(c)}
                        style={{ ...styles.row, background: selectedCustomer?.id === c.id ? '#e0e7ff' : '#fff' }}
                      >
                        <td style={styles.td}>{c.name}</td>
                        <td style={styles.td}>{c.phone || '-'}</td>
                        <td style={styles.td}>LKR {parseFloat(c.total_credit).toFixed(2)}</td>
                        <td style={styles.td}>LKR {parseFloat(c.total_paid).toFixed(2)}</td>
                        <td style={{ ...styles.td, color: parseFloat(c.balance) > 0 ? '#ef4444' : '#16a34a', fontWeight: 'bold' }}>
                          LKR {parseFloat(c.balance).toFixed(2)}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table></div>
              {creditList.length > 5 && (
                <button onClick={() => setShowAllCredit(!showAllCredit)} style={{ marginTop: '0.5rem', padding: '6px 14px', background: '#fff', color: '#4f46e5', border: '1px solid #ddd', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' }}>
                  {showAllCredit ? '▲ Show less' : `▼ Show all ${creditList.length}`}
                </button>
              )}
            </div>
          )}

          {selectedCustomer && history && (
            <div style={styles.detail}>
<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
  <h3 style={{ fontSize: '18px', margin: 0 }}>{history.name}</h3>
  <button
    onClick={() => {
      const saleType = history.is_vip ? 'cash' : 'credit';
      navigate('/invoices/create?type=' + saleType + '&customer_id=' + history.id + '&customer_name=' + encodeURIComponent(history.name));
    }}
    style={styles.newInvoiceBtn}
  >
    🧾 New Invoice
  </button>
</div>            

<p style={styles.detailText}>Phone: {history.phone || '-'}</p>
              <div style={styles.balanceBox}>
                <div style={styles.balanceItem}>
                  <p style={styles.balanceLabel}>Total Credit</p>
                  <p style={styles.balanceValue}>LKR {parseFloat(history.total_credit).toFixed(2)}</p>
                </div>
                <div style={styles.balanceItem}>
                  <p style={styles.balanceLabel}>Total Paid</p>
                  <p style={{ ...styles.balanceValue, color: '#16a34a' }}>LKR {parseFloat(history.total_paid).toFixed(2)}</p>
                </div>
                <div style={styles.balanceItem}>
                  <p style={styles.balanceLabel}>Balance Due</p>
                  <p style={{ ...styles.balanceValue, color: parseFloat(history.balance) > 0 ? '#ef4444' : '#16a34a' }}>
                    LKR {parseFloat(history.balance).toFixed(2)}
                  </p>
                </div>
              </div>

             <div style={styles.tabs}>
  <button onClick={() => setActiveTab('credit')} style={activeTab === 'credit' ? styles.tabActive : styles.tab}>Add Credit</button>
  <button onClick={() => setActiveTab('payment')} style={activeTab === 'payment' ? styles.tabActive : styles.tab}>Add Payment</button>
  <button onClick={() => setActiveTab('history')} style={activeTab === 'history' ? styles.tabActive : styles.tab}>History</button>
  <button onClick={() => setActiveTab('invoices')} style={activeTab === 'invoices' ? styles.tabActive : styles.tab}>📋 Invoices</button>
  <button onClick={() => setActiveTab('analytics')} style={activeTab === 'analytics' ? styles.tabActive : styles.tab}>📊 Analytics</button>
</div>
{parseFloat(history?.balance) === 0 && (
  <button
    onClick={() => handleDeleteCustomer(selectedCustomer)}
    style={styles.deleteCustomerBtn}
  >
    🗑️ Delete Customer
  </button>
)}

              {activeTab === 'credit' && (
                <div style={styles.tabContent}>
                  <input style={styles.modalInput} type="number" placeholder="Credit Amount (LKR)" value={creditAmount} onChange={(e) => setCreditAmount(e.target.value)} min="0" />
                  <input style={styles.modalInput} type="text" placeholder="Note (optional)" value={creditNote} onChange={(e) => setCreditNote(e.target.value)} />
                  <button onClick={handleAddCredit} style={styles.creditBtn}>Add Credit</button>
                </div>
              )}

              {activeTab === 'payment' && (
                <div style={styles.tabContent}>
                  <input style={styles.modalInput} type="number" placeholder="Payment Amount (LKR)" value={paymentAmount} onChange={(e) => setPaymentAmount(e.target.value)} min="0" />
                  <input style={styles.modalInput} type="text" placeholder="Note (optional)" value={paymentNote} onChange={(e) => setPaymentNote(e.target.value)} />
                  <button onClick={handleAddPayment} style={styles.paymentBtn}>Record Payment</button>
                </div>
              )}

              {activeTab === 'history' && (
                <div style={styles.tabContent}>
                  {history.history?.length === 0 ? (
                    <p style={{ color: '#888', fontSize: '14px' }}>No transactions yet</p>
                  ) : (
                    history.history?.map((h, i) => (
                      <div key={i} style={styles.historyItem}>
                        <div>
                          <p style={styles.historyNote}>{h.note}</p>
                          <p style={styles.historyDate}>{new Date(h.created_at).toLocaleDateString()}</p>
                        </div>
                        <p style={{ ...styles.historyAmount, color: h.amount > 0 ? '#ef4444' : '#16a34a' }}>
                          {h.amount > 0 ? '+' : ''}LKR {parseFloat(h.amount).toFixed(2)}
                        </p>
                      </div>
                    ))
                  )}
                </div>
              )}

              {activeTab === 'invoices' && (
                <div style={styles.tabContent}>
                  {loadingInvoices ? (
                    <p style={{ color: '#888', fontSize: '14px' }}>Loading invoices...</p>
                  ) : customerInvoices?.invoices?.length === 0 ? (
                    <p style={{ color: '#888', fontSize: '14px' }}>No invoices found for this customer</p>
                  ) : (
                    customerInvoices?.invoices?.map((inv, i) => (
                      <div key={i} style={{ ...styles.historyItem, cursor: 'pointer' }} onClick={() => navigate('/invoices?open=' + inv.id)}>
                        <div>
                          <p style={styles.historyName}>Invoice #{inv.invoice_number}</p>
                          <p style={styles.historyDate}>{new Date(inv.created_at).toLocaleDateString()}</p>
                          <p style={styles.historyDate}>{inv.items?.length} items</p>
                        </div>
                        <p style={{ ...styles.historyAmount, color: '#4f46e5' }}>
                          LKR {parseFloat(inv.total_amount).toFixed(2)}
                        </p>
                      </div>
                    ))
                  )}
                </div>
              )}

              {activeTab === 'analytics' && (
                <div style={styles.tabContent}>
                  {loadingInvoices ? (
                    <p style={{ color: '#888', fontSize: '14px' }}>Loading analytics...</p>
                  ) : (
                    <>
                      <div style={styles.analyticsGrid}>
                        <div style={styles.analyticsCard}>
                          <p style={styles.analyticsLabel}>Total Spent</p>
                          <p style={styles.analyticsValue}>LKR {customerInvoices?.total_spent?.toFixed(2) || '0.00'}</p>
                        </div>
                        <div style={styles.analyticsCard}>
                          <p style={styles.analyticsLabel}>Total Visits</p>
                          <p style={styles.analyticsValue}>{customerInvoices?.total_visits || 0}</p>
                        </div>
                        <div style={styles.analyticsCard}>
                          <p style={styles.analyticsLabel}>Average Bill</p>
                          <p style={styles.analyticsValue}>LKR {customerInvoices?.average_bill?.toFixed(2) || '0.00'}</p>
                        </div>
                      </div>

                      <h4 style={{ fontSize: '14px', margin: '1rem 0 0.75rem', color: '#444' }}>❤️ Favourite Products:</h4>
                      {customerInvoices?.favourite_products?.length === 0 ? (
                        <p style={{ color: '#888', fontSize: '14px' }}>No data yet</p>
                      ) : (
                        customerInvoices?.favourite_products?.map((p, i) => (
                          <div key={i} style={styles.historyItem}>
                            <div>
                              <p style={styles.historyName}>
                                {i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : '⭐'} {p.name}
                              </p>
                              <p style={styles.historyDate}>Bought {p.count} times</p>
                            </div>
                            <p style={{ ...styles.historyAmount, color: '#16a34a' }}>
                              LKR {parseFloat(p.total).toFixed(2)}
                            </p>
                          </div>
                        ))
                      )}

                      
                    </>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: { padding: '2rem' },
  title: { fontSize: '24px', marginBottom: '1.5rem' },
  subtitle: { fontSize: '16px', marginBottom: '1rem' },
  card: { background: '#fff', padding: '1.5rem', borderRadius: '12px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', marginBottom: '1.5rem' },
  form: { display: 'flex', gap: '1rem', flexWrap: 'wrap' },
  input: { padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', flex: 1, minWidth: '150px' },
  button: { padding: '10px 20px', background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', cursor: 'pointer' },
  search: { width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', marginBottom: '1rem', boxSizing: 'border-box' },
  layout: { display: 'flex', gap: '1.5rem', alignItems: 'flex-start', flexWrap: 'wrap' },
  loaderWrapper: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '4rem' },
  spinner: { width: '40px', height: '40px', border: '4px solid #e0e7ff', borderTop: '4px solid #4f46e5', borderRadius: '50%', animation: 'spin 0.8s linear infinite' },
  loaderText: { marginTop: '1rem', color: '#888', fontSize: '14px' },
  table: { flex: 2, minWidth: '300px', borderCollapse: 'collapse', background: '#fff', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' },
  th: { padding: '12px 16px', background: '#4f46e5', color: '#fff', textAlign: 'left', fontSize: '14px' },
  td: { padding: '12px 16px', borderBottom: '1px solid #f0f0f0', fontSize: '14px', cursor: 'pointer' },
  row: { transition: 'background 0.2s' },
  detail: { flex: 1, minWidth: '280px', background: '#fff', borderRadius: '12px', padding: '1.5rem', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' },
  detailTitle: { fontSize: '18px', marginBottom: '0.5rem' },
  detailText: { fontSize: '14px', color: '#888', marginBottom: '1rem' },
  balanceBox: { display: 'flex', gap: '0.5rem', marginBottom: '1.5rem', flexWrap: 'wrap' },
  balanceItem: { flex: 1, background: '#f5f3ff', borderRadius: '8px', padding: '0.75rem', minWidth: '80px' },
  balanceLabel: { fontSize: '11px', color: '#888', margin: '0 0 4px' },
  balanceValue: { fontSize: '16px', fontWeight: 'bold', margin: 0, color: '#4f46e5' },
  tabs: { display: 'flex', gap: '0.5rem', marginBottom: '1rem' },
  tab: { flex: 1, padding: '8px', background: '#fff', border: '1px solid #ddd', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  tabActive: { flex: 1, padding: '8px', background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  tabContent: { display: 'flex', flexDirection: 'column', gap: '0.75rem' },
  modalInput: { width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box' },
  creditBtn: { padding: '10px', background: '#ef4444', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  paymentBtn: { padding: '10px', background: '#16a34a', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  historyItem: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #f0f0f0' },
  historyNote: { fontSize: '13px', margin: '0 0 2px', fontWeight: '500' },
  historyDate: { fontSize: '11px', color: '#888', margin: 0 },
  historyAmount: { fontSize: '14px', fontWeight: 'bold' },
  deleteCustomerBtn: { width: '100%', padding: '10px', background: '#fee2e2', color: '#ef4444', border: '1px solid #ef4444', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', marginTop: '1rem' },
  outstandingBox: { background: '#fee2e2', border: '1px solid #fca5a5', borderRadius: '12px', padding: '1rem 1.5rem', marginBottom: '1.5rem' },
outstandingTitle: { fontWeight: '500', color: '#991b1b', marginBottom: '0.75rem', fontSize: '14px' },
outstandingList: { display: 'flex', flexDirection: 'column', gap: '0.5rem', marginBottom: '0.75rem' },
outstandingItem: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#fff', padding: '8px 12px', borderRadius: '8px' },
outstandingName: { fontSize: '14px', fontWeight: '500' },
outstandingBalance: { fontSize: '14px', color: '#ef4444', fontWeight: 'bold' },
outstandingTotal: { display: 'flex', justifyContent: 'space-between', fontSize: '14px', paddingTop: '0.5rem', borderTop: '1px solid #fca5a5' },
newInvoiceBtn: { padding: '6px 14px', background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
analyticsGrid: { display: 'flex', gap: '0.5rem', marginBottom: '1rem', flexWrap: 'wrap' },
analyticsCard: { flex: 1, background: '#f5f3ff', borderRadius: '8px', padding: '0.75rem', minWidth: '80px', textAlign: 'center' },
analyticsLabel: { fontSize: '11px', color: '#888', margin: '0 0 4px' },
analyticsValue: { fontSize: '16px', fontWeight: 'bold', color: '#4f46e5', margin: 0 },
vipBadge: { background: '#fef3c7', color: '#92400e', padding: '8px 12px', borderRadius: '8px', fontSize: '13px', fontWeight: '500', marginTop: '1rem', textAlign: 'center' },
templateBtn: { padding: '8px 14px', background: '#e0e7ff', color: '#4f46e5', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
importBtn: { padding: '8px 14px', background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
importResult: { background: '#f0fdf4', border: '1px solid #86efac', borderRadius: '8px', padding: '1rem', marginTop: '1rem' },
};

export default Customers;